import { useAppSelector } from "@/redux/hooks";
import { useSplitClient } from "@splitsoftware/splitio-react";
import { useEffect, useState } from "react";
import ConfigUtils from "../ConfigUtils";

/** Split name for the "Download purchases as CSV" feature on profile. Create this in Split.io if needed. */
export const USER_EXPORT_TRANSACTIONS_CSV_SPLIT = "brandclub_user_export_transactions_csv";

export const useExportTransactionsCsvEnabled = () => {
  const userProfile = useAppSelector((state) => state.userProfile);
  const [treatment, setTreatment] = useState<"on" | "off" | "control">("off");
  const splitIO = useSplitClient();

  useEffect(() => {
    const splitTreatment = splitIO.client?.getTreatment(
      USER_EXPORT_TRANSACTIONS_CSV_SPLIT,
      {
        email: userProfile?.email ?? "",
      }
    ) as "on" | "off" | "control";

    if (splitTreatment && splitTreatment !== "control") {
      setTreatment(splitTreatment);
    }
  }, [splitIO, userProfile]);

  return {
    enabled: treatment === "on",
    treatment,
  };
};
